module.exports = __webpack_public_path__ + "static/media/3BOX-101-badge.7513f015.svg";